import { IonChip, IonIcon } from '@ionic/react';
import clsx from 'clsx';
import { close } from 'ionicons/icons';
import React from 'react';
interface FilterChipProps {
  label: string;
  clickable?: boolean;
  onRemove?: () => void;
  onClick?: () => void;
  removable?: boolean;
  className?: string;
}

const FilterChip: React.FC<FilterChipProps> = ({
  label,
  clickable = false,
  onRemove,
  onClick,
  className = '',
  removable = false,
}) => {
  const handleRemoval = () => {
    if (!removable) return;
    if (onRemove) onRemove();
  };
  const handleSelection = () => {
    if (!clickable) if (onClick) onClick();
  };
  const wrapperStyle = clsx(className, 'high-emphasis-text capitalize m-0');
  return (
    <IonChip
      onClick={handleSelection}
      className={wrapperStyle}
      style={{
        '--background': 'transparent',
      }}
    >
      {label}
      <IonIcon onClick={handleRemoval} icon={close}></IonIcon>
    </IonChip>
  );
};

export default FilterChip;
